<template src='./PackageConfigList.html'></template>
<script>
import { orderBy } from "@progress/kendo-data-query";
import CommandCell from "@/components/CommandCellTemplateWithoutAuditLog.vue";
// import { createNamespacedHelpers } from "vuex";
// const { mapState } = createNamespacedHelpers("packageConfig");
// import { MESSAGES } from "@/utils/constants";
// import { notify, notifyApiError } from "@/utils/notification-helper";
import DialogBox from "@/components/DialogBox.vue";

export default {
  data: function() {
    return {
      // addoredit: false,
      gridData: [],
      skip: 0,
      take: 10,
      pageSize: 10,
      search: "",
      pageable: {
        pageSizes: true,
        previousNext: true
      },
      add: true,
      sort: [{ field: "id", dir: "asc" }],
      columns: [
        { field: "id", title: "ID", hidden: true},
        { field: "name", title: "Name" },

        { field: "productName", title: "Product" },

        { cell: CommandCell, title: "Actions", width: "200px" }
      ],
      dataItems: [],
      removeData:{}
    };
  },
  components: {
    DialogBox
  },
  methods: {
    sortChangeHandler: function(e) {
      this.sort = e.sort;
    },
    pageChangeHandler: function(event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    showAdd: function() {
      this.add = true;
    },
    remove: function(item) {
      this.removeData = item;
      this.$refs.removeTenantDtl.openWindow();
    },
    openForm() {
      this.$router.push({ name: "addPackage", params: { add: true } });
    },
    OkMethod() {
      return this.$store
        .dispatch("packageConfig/removePackage", this.removeData)
        .then(() => {
          //   notify(MESSAGES.CHANGES_SAVE_SUCCESS);
        });
      // .catch(notifyApiError);
    },
    closeDialog() {
      this.$refs.removeTenantDtl.closeWindow();
    },
    edit: function(item) {
      return this.$store.dispatch("packageConfig/editPackage", item.dataItem); //item.dataItem.id
    },
    async getDataOnload() {
      this.$store.dispatch("getPackage");
    }
  },
  computed: {
    // ...mapState({
    //   packList: state => state.packs
    // }),
    packList() {
      return this.$store.state.packageData;
    },
    total() {
      if(this.search){
        return this.items ? this.items.length : 0;
      }else{
        return this.packList ? this.packList.length : 0;
      }
    },
    items: {
      get: function() {
         if(this.search){
            let data = this.packList.filter(pack => `${pack.productName}${pack.name}`.match(new RegExp(this.search, "i")));
            return orderBy(data.slice(this.skip, this.take + this.skip), this.sort);
         }else{
            return orderBy(
              this.packList.slice(this.skip, this.take + this.skip),
              this.sort
            );
         }
      }
    }
  },
  created: function() {
    this.getDataOnload();
  }
};
</script>
